import React, { useEffect } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import { getActiveAddTab, setActiveAddTab } from 'ducks/editor/tabs'

import './TabBar.css'

const TabBar = props => {
  const { activeTab, extraProps, tabs } = props

  const handleClick = id => {
    const { setActiveAddTab } = props

    return setActiveAddTab(id)
  }

  useEffect(() => {
    const { setActiveAddTab } = props
    if (!activeTab && tabs.length) setActiveAddTab(tabs[0].id)

    return () => setActiveAddTab('component')
  }, [])

  const currentTab = tabs.find(tab => tab.id === activeTab)

  return (
    <>
      <div className="editor-add-panel-tabs">
        {tabs.map(({ id, title }) => (
          <div
            key={id}
            className={classNames('editor-add-panel-tab', {
              'editor-add-panel-tab-active': activeTab === id,
            })}
            onClick={() => handleClick(id)}
          >
            {title}
          </div>
        ))}
      </div>
      {currentTab ? <currentTab.component {...extraProps} /> : null}
    </>
  )
}

const mapStateToProps = state => ({
  activeTab: getActiveAddTab(state),
})

export default connect(mapStateToProps, { setActiveAddTab })(TabBar)
